export const HOMEPAGE = '/consultaDocumentosCSV/';

/**
 * Listado de páginas
 * @readonly
 * @enum {string}
 */
export const ROUTES = Object.freeze({
  HOME: '/',
});
